var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimensions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.922 7.917a.833.833 0 00-1.179 0l-5.955 5.955a.417.417 0 00.295.711h.834a.417.417 0 01.416.417v4.167a.833.833 0 00.834.833h2.083a.833.833 0 00.833-.833v-2.084a1.25 1.25 0 112.5 0v2.084a.833.833 0 00.834.833H17.5a.833.833 0 00.833-.833V15a.417.417 0 01.417-.417h.833a.417.417 0 00.295-.711z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.167 0H.833A.833.833 0 000 .833v18.334A.833.833 0 00.833 20H3.75a.417.417 0 00.417-.417v-2.291a.417.417 0 00-.417-.417H2.083a.625.625 0 010-1.25H3.75a.417.417 0 00.417-.417v-2.083a.417.417 0 00-.417-.417H2.083a.625.625 0 010-1.25H3.75a.417.417 0 00.417-.416V8.958a.417.417 0 00-.417-.416H2.083a.625.625 0 010-1.25H3.75a.417.417 0 00.417-.417V4.583a.417.417 0 01.416-.416h2.292a.417.417 0 00.417-.417V2.083a.625.625 0 011.25 0V3.75a.417.417 0 00.416.417h2.084a.417.417 0 00.416-.417V2.083a.625.625 0 011.25 0V3.75a.417.417 0 00.417.417h2.083a.417.417 0 00.417-.417V2.083a.625.625 0 011.25 0V3.75a.417.417 0 00.417.417h2.291A.417.417 0 0020 3.75V.833A.833.833 0 0019.167 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimensions);
export default __webpack_public_path__ + "static/media/dimensions.2ed96095.svg";
export { ForwardRef as ReactComponent };